export default __webpack_public_path__ + "static/media/2c80d2ced9451189047bc6f0c8a54852.8c4c19c4.gif";